"use strict";
/*
 * Created on 04 29 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * @author Jaroslav Sevcik
 */


var SelloutImpactReportDetailFilterDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutImpactReportDetailFilterDTO, _DomainObject_1$Domai);

  function SelloutImpactReportDetailFilterDTO(filter, releaseIds) {
    var _this;

    _classCallCheck(this, SelloutImpactReportDetailFilterDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportDetailFilterDTO).call(this));
    _this.filter = filter;
    _this.releaseIds = releaseIds;
    return _this;
  }

  return SelloutImpactReportDetailFilterDTO;
}(DomainObject_1.DomainObject);

exports.SelloutImpactReportDetailFilterDTO = SelloutImpactReportDetailFilterDTO;